module.exports = __webpack_public_path__ + "img/structure_2.7cb3cfec.png";